var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
const exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
const get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
const eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
const findLatestVersion = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
const findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
const findSingletonVersionKey = (scope, key, eager) => {
	const versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
const getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
const getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	const versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
const fail = (msg) => {
	throw new Error(msg);
}
const failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
const warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
const init = (fn) => (function(scopeName, key, eager, c, d) {
	const promise = __webpack_require__.I(scopeName);
	if (promise?.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

const useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
const load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
const loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
const loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
const loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
const loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	const version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
const installedModules = {};
const moduleToHandlerMapping = {
	59302: () => (loadSingletonVersion("default", "react", false, [,[1,18],[1,17],1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	55931: () => (loadSingleton("default", "react", false, () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	50318: () => (loadSingletonVersion("default", "react", false, [1,18,3,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	31245: () => (loadSingletonVersion("default", "react", false, [0,16,8,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	17046: () => (loadSingletonVersion("default", "@platform/icons", false, [1,1,28,2], () => (__webpack_require__.e(9213).then(() => (() => (__webpack_require__(79213))))))),
	99109: () => (loadSingletonVersion("default", "@platform/elements", false, [1,4,255,0], () => (Promise.all([__webpack_require__.e(2699), __webpack_require__.e(7880), __webpack_require__.e(6395), __webpack_require__.e(2548), __webpack_require__.e(3798), __webpack_require__.e(7865), __webpack_require__.e(7045), __webpack_require__.e(9302), __webpack_require__.e(318), __webpack_require__.e(1245), __webpack_require__.e(4476), __webpack_require__.e(6485), __webpack_require__.e(8437), __webpack_require__.e(1006), __webpack_require__.e(3655), __webpack_require__.e(7046), __webpack_require__.e(8536), __webpack_require__.e(1015), __webpack_require__.e(1631), __webpack_require__.e(4347), __webpack_require__.e(5162)]).then(() => (() => (__webpack_require__(47230))))))),
	31487: () => (loadSingleton("default", "@interhyp/platform-request", false, () => (__webpack_require__.e(2734).then(() => (() => (__webpack_require__(32734))))))),
	1667: () => (loadSingletonVersion("default", "react-redux", false, [1,9,3,0], () => (Promise.all([__webpack_require__.e(7965), __webpack_require__.e(3655), __webpack_require__.e(6084)]).then(() => (() => (__webpack_require__(97965))))))),
	52587: () => (loadSingletonVersion("default", "redux", false, [1,4,2,1], () => (__webpack_require__.e(8238).then(() => (() => (__webpack_require__(68238))))))),
	10275: () => (loadSingletonVersion("default", "react-router", false, [4,5,3,4], () => (Promise.all([__webpack_require__.e(5785), __webpack_require__.e(6347), __webpack_require__.e(668)]).then(() => (() => (__webpack_require__(56347))))))),
	55671: () => (loadSingletonVersion("default", "@platform/theme", false, [1,4,24,4], () => (Promise.all([__webpack_require__.e(832), __webpack_require__.e(9858), __webpack_require__.e(7159), __webpack_require__.e(6818), __webpack_require__.e(509)]).then(() => (() => (__webpack_require__(10832))))))),
	5677: () => (loadSingletonVersion("default", "@interhyp/api-documents", false, [4,1,12,1], () => (Promise.all([__webpack_require__.e(6356), __webpack_require__.e(1015), __webpack_require__.e(4834), __webpack_require__.e(6816)]).then(() => (() => (__webpack_require__(6816))))))),
	13307: () => (loadSingletonVersion("default", "@interhyp/platform-module", false, [1,1,43,24], () => (Promise.all([__webpack_require__.e(5973), __webpack_require__.e(9302), __webpack_require__.e(3583), __webpack_require__.e(4226), __webpack_require__.e(6420), __webpack_require__.e(9858), __webpack_require__.e(3756), __webpack_require__.e(7159), __webpack_require__.e(2058), __webpack_require__.e(3645)]).then(() => (() => (__webpack_require__(55973))))))),
	13313: () => (loadSingletonVersion("default", "react-i18next", false, [1,17,0,19], () => (Promise.all([__webpack_require__.e(9359), __webpack_require__.e(1245), __webpack_require__.e(3655), __webpack_require__.e(1904)]).then(() => (() => (__webpack_require__(99359))))))),
	31055: () => (loadSingletonVersion("default", "@interhyp/api-baufi-now", false, [2,0,14,1], () => (Promise.all([__webpack_require__.e(6356), __webpack_require__.e(8598), __webpack_require__.e(4036)]).then(() => (() => (__webpack_require__(4036))))))),
	45904: () => (loadSingletonVersion("default", "i18next", false, [1,26,4,7], () => (__webpack_require__.e(2635).then(() => (() => (__webpack_require__(72635))))))),
	48356: () => (loadSingletonVersion("default", "@interhyp/platform-auth", false, [1,2,14,0], () => (Promise.all([__webpack_require__.e(9324), __webpack_require__.e(3583), __webpack_require__.e(9858), __webpack_require__.e(5656)]).then(() => (() => (__webpack_require__(93275))))))),
	6242: () => (loadSingletonVersion("default", "@interhyp/platform-layout", false, [1,1,96,5], () => (Promise.all([__webpack_require__.e(2699), __webpack_require__.e(7880), __webpack_require__.e(8952), __webpack_require__.e(72), __webpack_require__.e(4226), __webpack_require__.e(4476), __webpack_require__.e(6485), __webpack_require__.e(8437), __webpack_require__.e(6420), __webpack_require__.e(1006), __webpack_require__.e(7898), __webpack_require__.e(3756), __webpack_require__.e(9926), __webpack_require__.e(5197), __webpack_require__.e(9808)]).then(() => (() => (__webpack_require__(10072))))))),
	10803: () => (loadSingletonVersion("default", "@interhyp/api-devtools", false, [1,1,1,6], () => (Promise.all([__webpack_require__.e(6356), __webpack_require__.e(253)]).then(() => (() => (__webpack_require__(20253))))))),
	20250: () => (loadSingletonVersion("default", "@interhyp/platform-navigation", false, [1,1,17,57], () => (Promise.all([__webpack_require__.e(2699), __webpack_require__.e(2989), __webpack_require__.e(6485), __webpack_require__.e(8437), __webpack_require__.e(7898), __webpack_require__.e(2627)]).then(() => (() => (__webpack_require__(32989))))))),
	23583: () => (loadSingletonVersion("default", "@interhyp/platform-router", false, [1,1,47,2], () => (Promise.all([__webpack_require__.e(8952), __webpack_require__.e(5785), __webpack_require__.e(7216), __webpack_require__.e(4226), __webpack_require__.e(4476), __webpack_require__.e(6420), __webpack_require__.e(9109), __webpack_require__.e(668), __webpack_require__.e(275), __webpack_require__.e(7516)]).then(() => (() => (__webpack_require__(37216))))))),
	33073: () => (loadSingleton("default", "react-dom", false, () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	34325: () => (loadSingleton("default", "@interhyp/platform-devtools", false, () => (__webpack_require__.e(4680).then(() => (() => (__webpack_require__(62299))))))),
	44887: () => (loadSingletonVersion("default", "@interhyp/platform-notification", false, [1,1,9,6], () => (Promise.all([__webpack_require__.e(484), __webpack_require__.e(4226)]).then(() => (() => (__webpack_require__(484))))))),
	70552: () => (loadSingletonVersion("default", "@interhyp/api-digital-account-check-advisor", false, [2,0,3,0], () => (Promise.all([__webpack_require__.e(6356), __webpack_require__.e(7715)]).then(() => (() => (__webpack_require__(37715))))))),
	84801: () => (loadSingletonVersion("default", "react", false, [,[4,16,0,0],0,[0,16,0,0],2], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	76356: () => (loadSingletonVersion("default", "@interhyp/platform-plugin", false, [1,1,7,9], () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(5931), __webpack_require__.e(2058), __webpack_require__.e(9110)]).then(() => (() => (__webpack_require__(59110))))))),
	28598: () => (loadSingletonVersion("default", "@interhyp/platform-eventbus", false, [1,1,6,15], () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(3561)]).then(() => (() => (__webpack_require__(83561))))))),
	51353: () => (loadSingletonVersion("default", "@interhyp/platform-eventbus", false, [1,1,6,7], () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(3561)]).then(() => (() => (__webpack_require__(83561))))))),
	71015: () => (loadSingletonVersion("default", "@interhyp/platform-eventbus", false, [1,1,6,30], () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(3561)]).then(() => (() => (__webpack_require__(83561))))))),
	14834: () => (loadSingletonVersion("default", "@interhyp/platform-demo", false, [1,1,4,552], () => (Promise.all([__webpack_require__.e(2699), __webpack_require__.e(9302), __webpack_require__.e(5931), __webpack_require__.e(1245), __webpack_require__.e(6485), __webpack_require__.e(3986)]).then(() => (() => (__webpack_require__(33986))))))),
	4515: () => (loadSingleton("default", "@interhyp/platform-plugin", false, () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(5931), __webpack_require__.e(2058), __webpack_require__.e(9110)]).then(() => (() => (__webpack_require__(59110))))))),
	16163: () => (loadSingletonVersion("default", "@interhyp/platform-plugin", false, [1,1,12,0], () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(5931), __webpack_require__.e(2058), __webpack_require__.e(9110)]).then(() => (() => (__webpack_require__(59110))))))),
	66193: () => (loadSingletonVersion("default", "@interhyp/platform-plugin", false, [1,1,9,0], () => (Promise.all([__webpack_require__.e(2058), __webpack_require__.e(6729)]).then(() => (() => (__webpack_require__(59110))))))),
	24969: () => (loadSingletonVersion("default", "@interhyp/platform-eventbus", false, [1,1,6,14], () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(3561)]).then(() => (() => (__webpack_require__(83561))))))),
	6361: () => (loadSingletonVersion("default", "@interhyp/platform-value", false, [1,1,4,9], () => (Promise.all([__webpack_require__.e(1525), __webpack_require__.e(9302)]).then(() => (() => (__webpack_require__(51525))))))),
	91934: () => (loadSingletonVersion("default", "@interhyp/platform-storage", false, [1,1,5,10], () => (Promise.all([__webpack_require__.e(9302), __webpack_require__.e(5931), __webpack_require__.e(2603), __webpack_require__.e(3554)]).then(() => (() => (__webpack_require__(53554))))))),
	89858: () => (loadSingletonVersion("default", "@interhyp/platform-request", false, [1,1,5,29], () => (__webpack_require__.e(2734).then(() => (() => (__webpack_require__(32734))))))),
	46497: () => (loadSingletonVersion("default", "react-dom", false, [0,16,8,0], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))))),
	60249: () => (loadSingletonVersion("default", "react-dom", false, [,[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))))),
	81783: () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	91150: () => (loadSingletonVersion("default", "react-dom", false, [0,17,0,0], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))))),
	92902: () => (loadSingletonVersion("default", "react", false, [0,17,0,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	40047: () => (loadSingletonVersion("default", "@interhyp/platform-eventbus", false, [1,1,6,27], () => (__webpack_require__.e(5942).then(() => (() => (__webpack_require__(83561))))))),
	42933: () => (loadSingletonVersion("default", "@platform/elements", false, [1,4,246,0], () => (Promise.all([__webpack_require__.e(7880), __webpack_require__.e(6395), __webpack_require__.e(2548), __webpack_require__.e(3798), __webpack_require__.e(7865), __webpack_require__.e(7045), __webpack_require__.e(318), __webpack_require__.e(4476), __webpack_require__.e(8437), __webpack_require__.e(1006), __webpack_require__.e(3655), __webpack_require__.e(7046), __webpack_require__.e(8536), __webpack_require__.e(1015), __webpack_require__.e(1631), __webpack_require__.e(4347), __webpack_require__.e(5162)]).then(() => (() => (__webpack_require__(47230))))))),
	49417: () => (loadSingletonVersion("default", "@interhyp/platform-request", false, [1,1,5,26], () => (__webpack_require__.e(2734).then(() => (() => (__webpack_require__(32734))))))),
	52992: () => (loadSingletonVersion("default", "@interhyp/platform-auth", false, [1,2,13,7], () => (Promise.all([__webpack_require__.e(9324), __webpack_require__.e(3583), __webpack_require__.e(9858), __webpack_require__.e(5656)]).then(() => (() => (__webpack_require__(93275))))))),
	66688: () => (loadSingletonVersion("default", "@interhyp/platform-plugin", false, [1,1,12,1], () => (Promise.all([__webpack_require__.e(2058), __webpack_require__.e(6729)]).then(() => (() => (__webpack_require__(59110))))))),
	34226: () => (loadSingletonVersion("default", "@interhyp/platform-apm", false, [1,1,6,24], () => (Promise.all([__webpack_require__.e(2321), __webpack_require__.e(3236)]).then(() => (() => (__webpack_require__(60855))))))),
	86420: () => (loadSingletonVersion("default", "@interhyp/platform-plugin", false, [1,1,12,5], () => (Promise.all([__webpack_require__.e(2058), __webpack_require__.e(6729)]).then(() => (() => (__webpack_require__(59110))))))),
	47898: () => (loadSingletonVersion("default", "@platform/elements", false, [1,4,256,0], () => (Promise.all([__webpack_require__.e(2699), __webpack_require__.e(7880), __webpack_require__.e(6395), __webpack_require__.e(2548), __webpack_require__.e(3798), __webpack_require__.e(7865), __webpack_require__.e(7045), __webpack_require__.e(318), __webpack_require__.e(1245), __webpack_require__.e(4476), __webpack_require__.e(6485), __webpack_require__.e(8437), __webpack_require__.e(1006), __webpack_require__.e(3655), __webpack_require__.e(7046), __webpack_require__.e(8536), __webpack_require__.e(1015), __webpack_require__.e(1631), __webpack_require__.e(4347), __webpack_require__.e(5162)]).then(() => (() => (__webpack_require__(47230))))))),
	89926: () => (loadSingletonVersion("default", "react", false, [0,16,13,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	27159: () => (loadSingletonVersion("default", "@tanstack/react-query", false, [1,5,101,2], () => (Promise.all([__webpack_require__.e(2655), __webpack_require__.e(5931), __webpack_require__.e(6818), __webpack_require__.e(4150)]).then(() => (() => (__webpack_require__(62655))))))),
	54476: () => (loadSingletonVersion("default", "@interhyp/api-tracking", false, [1,1,8,2], () => (Promise.all([__webpack_require__.e(8952), __webpack_require__.e(1418)]).then(() => (() => (__webpack_require__(1418))))))),
	28437: () => (loadSingletonVersion("default", "react", false, [0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	51006: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0,,0],[1,18,0,0,,0],[1,17,0,0,,0],[1,16,0,0,,0],[1,15,0,0],[2,0,14,0],1,1,1,1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	81789: () => (loadSingletonVersion("default", "@interhyp/api-portal", false, [1,1,33,1], () => (Promise.all([__webpack_require__.e(1353), __webpack_require__.e(4834), __webpack_require__.e(7718)]).then(() => (() => (__webpack_require__(37718))))))),
	97768: () => (loadSingletonVersion("default", "@interhyp/platform-feature-flags", false, [2,0,1,15], () => (Promise.all([__webpack_require__.e(9858), __webpack_require__.e(7159), __webpack_require__.e(5069)]).then(() => (() => (__webpack_require__(35069))))))),
	5413: () => (loadSingletonVersion("default", "@interhyp/platform-storage", false, [1,1,7,11], () => (Promise.all([__webpack_require__.e(2603), __webpack_require__.e(1173)]).then(() => (() => (__webpack_require__(53554))))))),
	78286: () => (loadSingletonVersion("default", "@interhyp/platform-shortcuts", false, [2,0,8,47], () => (Promise.all([__webpack_require__.e(7010), __webpack_require__.e(8934)]).then(() => (() => (__webpack_require__(96553))))))),
	84714: () => (loadSingletonVersion("default", "@interhyp/api-toolarea", false, [1,1,13,0], () => (Promise.all([__webpack_require__.e(6356), __webpack_require__.e(4620)]).then(() => (() => (__webpack_require__(4620))))))),
	91701: () => (loadSingletonVersion("default", "@interhyp/api-values", false, [1,1,16,6], () => (Promise.all([__webpack_require__.e(5048), __webpack_require__.e(830)]).then(() => (() => (__webpack_require__(25048))))))),
	53655: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	91631: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0,,"rc"],[1,19,0,0],[1,18,0,0],[1,17,0,0],[1,16,8,0],1,1,1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	37378: () => (loadSingletonVersion("default", "@platform/elements", false, [1,4,225,2], () => (Promise.all([__webpack_require__.e(2699), __webpack_require__.e(7880), __webpack_require__.e(6395), __webpack_require__.e(2548), __webpack_require__.e(7865), __webpack_require__.e(7045), __webpack_require__.e(318), __webpack_require__.e(1245), __webpack_require__.e(4476), __webpack_require__.e(6485), __webpack_require__.e(8437), __webpack_require__.e(1006), __webpack_require__.e(7046), __webpack_require__.e(8536), __webpack_require__.e(4347), __webpack_require__.e(5162)]).then(() => (() => (__webpack_require__(47230))))))),
	12058: () => (loadSingletonVersion("default", "@interhyp/platform-devtools", false, [1,1,5,5], () => (__webpack_require__.e(4680).then(() => (() => (__webpack_require__(62299))))))),
	47429: () => (loadSingletonVersion("default", "@interhyp/platform-modal", false, [1,1,8,276], () => (Promise.all([__webpack_require__.e(3798), __webpack_require__.e(3655), __webpack_require__.e(1015), __webpack_require__.e(1631), __webpack_require__.e(7378), __webpack_require__.e(1421)]).then(() => (() => (__webpack_require__(73802))))))),
	86038: () => (loadSingletonVersion("default", "@interhyp/platform-effect", false, [1,1,5,310], () => (Promise.all([__webpack_require__.e(7898), __webpack_require__.e(9926), __webpack_require__.e(8175)]).then(() => (() => (__webpack_require__(40556))))))),
	16592: () => (loadSingletonVersion("default", "@interhyp/platform-layout", false, [1,1,97,2], () => (Promise.all([__webpack_require__.e(7880), __webpack_require__.e(8952), __webpack_require__.e(72), __webpack_require__.e(318), __webpack_require__.e(4226), __webpack_require__.e(4476), __webpack_require__.e(6420), __webpack_require__.e(1006), __webpack_require__.e(3756), __webpack_require__.e(9926), __webpack_require__.e(5197), __webpack_require__.e(5671), __webpack_require__.e(3046)]).then(() => (() => (__webpack_require__(10072))))))),
	80676: () => (loadSingletonVersion("default", "react-dom", false, [1,18,3,1], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))))),
	30668: () => (loadSingletonVersion("default", "react", false, [0,15], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	53601: () => (loadSingletonVersion("default", "@interhyp/api-routes", false, [1,2,20,4], () => (Promise.all([__webpack_require__.e(7007), __webpack_require__.e(8598), __webpack_require__.e(6193)]).then(() => (() => (__webpack_require__(97007))))))),
	76044: () => (loadSingletonVersion("default", "react-router", false, [1,5,3,4], () => (__webpack_require__.e(6347).then(() => (() => (__webpack_require__(56347))))))),
	47010: () => (loadSingletonVersion("default", "@interhyp/api-shortcuts", false, [1,1,5,5], () => (Promise.all([__webpack_require__.e(6356), __webpack_require__.e(8598), __webpack_require__.e(5809)]).then(() => (() => (__webpack_require__(65809))))))),
	42603: () => (loadSingletonVersion("default", "@interhyp/platform-value", false, [1,1,6,10], () => (__webpack_require__.e(1525).then(() => (() => (__webpack_require__(51525))))))),
	8536: () => (loadSingletonVersion("default", "prosemirror-state", false, [1,1,4,3], () => (Promise.all([__webpack_require__.e(2845), __webpack_require__.e(231), __webpack_require__.e(7639)]).then(() => (() => (__webpack_require__(42845))))))),
	24347: () => (loadSingletonVersion("default", "@tiptap/core", false, [1,2,7,0], () => (Promise.all([__webpack_require__.e(1138), __webpack_require__.e(9732), __webpack_require__.e(4116)]).then(() => (() => (__webpack_require__(91138))))))),
	998: () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],[1,16,0,0],[1,15,0,0],[2,0,14],1,1,1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	1994: () => (loadSingletonVersion("default", "prosemirror-history", false, [1,1,4,1], () => (Promise.all([__webpack_require__.e(9781), __webpack_require__.e(7639), __webpack_require__.e(1559)]).then(() => (() => (__webpack_require__(89781))))))),
	5291: () => (loadSingletonVersion("default", "react", false, [0,16,8], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	11817: () => (loadSingletonVersion("default", "@tiptap/core", false, [1,2,27,2], () => (Promise.all([__webpack_require__.e(1138), __webpack_require__.e(9732), __webpack_require__.e(4116)]).then(() => (() => (__webpack_require__(91138))))))),
	14513: () => (loadSingletonVersion("default", "@tiptap/react", false, [1,2,27,2], () => (Promise.all([__webpack_require__.e(3971), __webpack_require__.e(7549)]).then(() => (() => (__webpack_require__(13971))))))),
	24371: () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],[1,16,0,0],[1,15,0,0],1,1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	25910: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	26677: () => (loadSingletonVersion("default", "react", false, [0,16], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	27183: () => (loadSingletonVersion("default", "react-dom", false, [1,16,13,1], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	41727: () => (loadSingletonVersion("default", "react-dom", false, [0,16,6,0], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	43614: () => (loadSingletonVersion("default", "prosemirror-gapcursor", false, [1,1,3,2], () => (Promise.all([__webpack_require__.e(7671), __webpack_require__.e(231), __webpack_require__.e(9552)]).then(() => (() => (__webpack_require__(89552))))))),
	44966: () => (loadSingletonVersion("default", "@tiptap/core", false, [1,2,27,3], () => (Promise.all([__webpack_require__.e(1138), __webpack_require__.e(9732), __webpack_require__.e(4116)]).then(() => (() => (__webpack_require__(91138))))))),
	47359: () => (loadSingletonVersion("default", "react", false, [0,16,6,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	60447: () => (loadSingleton("default", "@platform/elements", false, () => (() => (__webpack_require__(47230))))),
	68934: () => (loadSingletonVersion("default", "react-dom", false, [,[1,18],[1,17],1], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	70456: () => (loadSingletonVersion("default", "@interhyp/platform-meta", false, [1,1,6,15], () => (__webpack_require__.e(7971).then(() => (() => (__webpack_require__(80352))))))),
	71079: () => (loadSingletonVersion("default", "react-dom", false, [0,16,8], () => (__webpack_require__.e(961).then(() => (() => (__webpack_require__(40961))))))),
	71948: () => (loadSingletonVersion("default", "prosemirror-dropcursor", false, [1,1,8,1], () => (Promise.all([__webpack_require__.e(7671), __webpack_require__.e(1714), __webpack_require__.e(3337)]).then(() => (() => (__webpack_require__(73337))))))),
	74443: () => (loadSingletonVersion("default", "react-hook-form", false, [4,7,81,0], () => (Promise.all([__webpack_require__.e(9785), __webpack_require__.e(9271)]).then(() => (() => (__webpack_require__(49785))))))),
	96162: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],[1,16,3],1,1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	76818: () => (loadSingletonVersion("default", "@tanstack/query-core", false, [4,5,104,1], () => (__webpack_require__.e(7934).then(() => (() => (__webpack_require__(37934))))))),
	52054: () => (loadSingletonVersion("default", "react", false, [,[1,18,0,0],[1,17,0,0],[1,16,3,0],1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	90192: () => (loadSingletonVersion("default", "react", false, [0,16,3,0], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	24150: () => (loadSingletonVersion("default", "react", false, [,[1,19],[1,18],1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	99732: () => (loadSingletonVersion("default", "prosemirror-transform", false, [1,1,10,2], () => (Promise.all([__webpack_require__.e(8262), __webpack_require__.e(8888)]).then(() => (() => (__webpack_require__(38262))))))),
	47170: () => (loadSingletonVersion("default", "prosemirror-schema-list", false, [1,1,4,1], () => (Promise.all([__webpack_require__.e(7671), __webpack_require__.e(231), __webpack_require__.e(3772)]).then(() => (() => (__webpack_require__(3772))))))),
	62541: () => (loadSingletonVersion("default", "prosemirror-commands", false, [1,1,6,2], () => (Promise.all([__webpack_require__.e(6762), __webpack_require__.e(7671), __webpack_require__.e(231)]).then(() => (() => (__webpack_require__(46762))))))),
	63603: () => (loadSingletonVersion("default", "prosemirror-keymap", false, [1,1,2,2], () => (Promise.all([__webpack_require__.e(7671), __webpack_require__.e(1396)]).then(() => (() => (__webpack_require__(61396))))))),
	78960: () => (loadSingletonVersion("default", "prosemirror-view", false, [1,1,42,3], () => (Promise.all([__webpack_require__.e(1575), __webpack_require__.e(7671), __webpack_require__.e(1714), __webpack_require__.e(3371)]).then(() => (() => (__webpack_require__(1575))))))),
	98218: () => (loadSingletonVersion("default", "prosemirror-model", false, [1,1,23,0], () => (__webpack_require__.e(8903).then(() => (() => (__webpack_require__(58903))))))),
	58006: () => (loadSingletonVersion("default", "react-dom", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],1,1], () => (Promise.all([__webpack_require__.e(961), __webpack_require__.e(318)]).then(() => (() => (__webpack_require__(40961))))))),
	65804: () => (loadSingletonVersion("default", "react", false, [,[1,19,0,0],[1,18,0,0],[1,17,0,0],1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	97671: () => (loadSingletonVersion("default", "prosemirror-state", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(2845), __webpack_require__.e(231), __webpack_require__.e(7639)]).then(() => (() => (__webpack_require__(42845))))))),
	20231: () => (loadSingletonVersion("default", "prosemirror-model", false, [1,1,0,0], () => (__webpack_require__.e(8903).then(() => (() => (__webpack_require__(58903))))))),
	91714: () => (loadSingletonVersion("default", "prosemirror-transform", false, [1,1,1,0], () => (Promise.all([__webpack_require__.e(8262), __webpack_require__.e(8888)]).then(() => (() => (__webpack_require__(38262))))))),
	13059: () => (loadSingletonVersion("default", "prosemirror-keymap", false, [1,1,0,0], () => (__webpack_require__.e(9015).then(() => (() => (__webpack_require__(61396))))))),
	54599: () => (loadSingletonVersion("default", "prosemirror-view", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(1575), __webpack_require__.e(1714), __webpack_require__.e(3371)]).then(() => (() => (__webpack_require__(1575))))))),
	37639: () => (loadSingletonVersion("default", "prosemirror-transform", false, [1,1,0,0], () => (Promise.all([__webpack_require__.e(8262), __webpack_require__.e(8888)]).then(() => (() => (__webpack_require__(38262))))))),
	81559: () => (loadSingletonVersion("default", "prosemirror-state", false, [1,1,2,2], () => (Promise.all([__webpack_require__.e(2845), __webpack_require__.e(231)]).then(() => (() => (__webpack_require__(42845))))))),
	45775: () => (loadSingletonVersion("default", "prosemirror-transform", false, [1,1,7,3], () => (Promise.all([__webpack_require__.e(8262), __webpack_require__.e(8888)]).then(() => (() => (__webpack_require__(38262))))))),
	28888: () => (loadSingletonVersion("default", "prosemirror-model", false, [1,1,21,0], () => (__webpack_require__.e(8903).then(() => (() => (__webpack_require__(58903))))))),
	93371: () => (loadSingletonVersion("default", "prosemirror-model", false, [1,1,25,12], () => (__webpack_require__.e(8903).then(() => (() => (__webpack_require__(58903))))))),
	79271: () => (loadSingletonVersion("default", "react", false, [,[1,19],[1,18],[1,17],[1,16,8,0],1,1,1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540))))))),
	31904: () => (loadSingletonVersion("default", "i18next", false, [0,26,2,0], () => (__webpack_require__.e(2635).then(() => (() => (__webpack_require__(72635))))))),
	56084: () => (loadSingletonVersion("default", "react", false, [,[1,19],[1,18,0],1], () => (__webpack_require__.e(6540).then(() => (() => (__webpack_require__(96540)))))))
};
// no consumes in initial chunks
const chunkMapping = {
	"231": [
		20231
	],
	"275": [
		10275
	],
	"318": [
		50318
	],
	"509": [
		52054,
		90192
	],
	"668": [
		30668
	],
	"830": [
		6361,
		91934
	],
	"1006": [
		51006
	],
	"1015": [
		71015
	],
	"1245": [
		31245
	],
	"1353": [
		51353
	],
	"1418": [
		24969
	],
	"1487": [
		31487
	],
	"1559": [
		81559
	],
	"1631": [
		91631
	],
	"1714": [
		91714
	],
	"1904": [
		31904
	],
	"2058": [
		12058
	],
	"2603": [
		42603
	],
	"2627": [
		16592,
		80676
	],
	"3371": [
		93371
	],
	"3583": [
		23583
	],
	"3645": [
		47429,
		86038
	],
	"3655": [
		53655
	],
	"3756": [
		81789,
		97768
	],
	"3772": [
		45775
	],
	"3807": [
		13307,
		13313,
		31055,
		45904
	],
	"3986": [
		40047,
		42933,
		49417,
		52992,
		66688
	],
	"4116": [
		47170,
		62541,
		63603,
		78960,
		98218
	],
	"4150": [
		24150
	],
	"4226": [
		34226
	],
	"4347": [
		24347
	],
	"4476": [
		54476
	],
	"4592": [
		6242,
		10803,
		20250,
		23583,
		33073,
		34325,
		44887,
		70552,
		84801
	],
	"4834": [
		14834
	],
	"5162": [
		998,
		1994,
		5291,
		11817,
		14513,
		24371,
		25910,
		26677,
		27183,
		41727,
		43614,
		44966,
		47359,
		60447,
		68934,
		70456,
		71079,
		71948,
		74443,
		96162
	],
	"5197": [
		5413,
		78286,
		84714,
		91701
	],
	"5339": [
		1667,
		52587
	],
	"5671": [
		55671
	],
	"5931": [
		55931
	],
	"6084": [
		56084
	],
	"6193": [
		66193
	],
	"6356": [
		76356
	],
	"6420": [
		86420
	],
	"6485": [
		46497,
		60249,
		81783,
		91150,
		92902
	],
	"6818": [
		76818
	],
	"7010": [
		47010
	],
	"7046": [
		17046
	],
	"7159": [
		27159
	],
	"7378": [
		37378
	],
	"7516": [
		53601,
		76044
	],
	"7549": [
		58006,
		65804
	],
	"7639": [
		37639
	],
	"7671": [
		97671
	],
	"7718": [
		16163
	],
	"7898": [
		47898
	],
	"8356": [
		48356
	],
	"8437": [
		28437
	],
	"8536": [
		8536
	],
	"8598": [
		28598
	],
	"8888": [
		28888
	],
	"9050": [
		5677
	],
	"9109": [
		99109
	],
	"9271": [
		79271
	],
	"9302": [
		59302
	],
	"9552": [
		13059,
		54599
	],
	"9732": [
		99732
	],
	"9752": [
		4515
	],
	"9858": [
		89858
	],
	"9926": [
		89926
	]
};
const startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			const onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			const onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				const promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}